import { Box } from "@mui/material";
import { DotLoader } from "react-spinners";

export default function Loader() {
  // TODO: Can be improved in the future
  return (
    <Box sx={{ marginTop: "40vh", marginLeft: "50%", marginBottom: "2vh" }}>
      Loading...
      <DotLoader color="#243573" />
    </Box>
  );
}